import {
  GetHistoryTransaction,
  OyResponse,
  ProductWorkflow,
  Rule,
  RuleRequest,
  WorkflowHistory,
} from '@oy/types';
import axios, {
  BUSINESS_PAYMENT_PREFIX,
  BUSINESS_PREFIX_V2,
} from 'src/clients/axios';

export function setProductWorkflow() {
  const ruleRequest: RuleRequest = {
    product_name: 'INTERNATIONAL_REMITTANCE',
    domain: 'BUSINESS_DASHBOARD',
    workflow_type: 'APPROVAL',
    workflow_rules: [],
  };

  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/pw/product`,
    data: ruleRequest,
  });
}

export function getRules(productName: string) {
  return axios.request<OyResponse<ProductWorkflow>>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/pw/rule?product_name=${productName}&domain=BUSINESS_DASHBOARD&workflow_type=APPROVAL`,
  });
}

export function setRule(
  rule: Rule[],
  productName: string,
  singleRule: boolean = false,
) {
  const ruleRequest: RuleRequest = {
    product_name: productName,
    domain: 'BUSINESS_DASHBOARD',
    workflow_type: 'APPROVAL',
    workflow_rules: rule,
    single_rule: singleRule,
  };
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/pw/rule`,
    data: ruleRequest,
  });
}

export function getApprovalConfig() {
  return axios({
    method: 'get',
    url: `${BUSINESS_PREFIX_V2}/international/approval`,
  });
}

export function setApprovalConfig(isActive: boolean) {
  return axios({
    method: 'post',
    url: `${BUSINESS_PREFIX_V2}/international/approval`,
    data: {
      is_active: isActive,
    },
  });
}

export function getHistoryTransaction(data: GetHistoryTransaction) {
  return axios.request<OyResponse<WorkflowHistory>>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/pw/history`,
    disableToast: true,
    params: data,
  });
}

export function getHistoryTransactionV2(data: GetHistoryTransaction) {
  return axios.request<OyResponse<WorkflowHistory>>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/approval/v2/history`,
    disableToast: true,
    params: data,
  });
}

export function getUserPermission(productName: string, actorName: string) {
  const data = {
    product_name: productName,
    domain: 'BUSINESS_DASHBOARD',
    workflow_type: 'APPROVAL',
    actor_name: actorName,
  };
  return axios({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/b2x/pw/actor/permission`,
    params: data,
  });
}
